(function () {
  class ReelSpinnerVisualNudge extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreapp,
      numPostapp,
      dynamicSpinner,
      nudgeReel
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreapp,
        numPostapp,
        dynamicSpinner,
        nudgeReel
      );
      this._reelId = parseInt(reelId.replace('reel', ''));
    }

    /**
     * function to map the symbol Ids on the data object to the visual sprites
     **/

    updateSymbols() {
      let symbolData = this._reelSpinnerData.getSymbolData();
      let ids = [];
      let positions = [];
      for (let i = 0; i < symbolData.length; ++i) {
        ids.push(symbolData[i].symId);
        let offset = this._symbolOffset[symbolData[i].symId];
        //let yPos = symbolData[i].yPos + offsets[i];
        let yPos = symbolData[i].yPos + 0;
        positions.push({ x: offset.x, y: yPos });
      }
      this.updateSymbolIds(ids);
      this.updateSymbolPositions(positions);
    }

    performNudge(nudgeTime) {
      this._reelSpinnerData.nudgeReel(nudgeTime);
    }
  }

  function create(json) {
    let numPreapp = json.numPreappertureSymbols || 2;
    let numPostapp = json.numPostappertureSymbols || 2;
    return new ReelSpinnerVisualNudge(
      json.ID,
      json.ID + ' container',
      json.appertureHeight,
      json.slotMachineName,
      json.minSymbolSpacing,
      1,
      numPreapp,
      numPostapp,
      gameController.dynamicSpinner,
      json.nudgeReel
    );
  }

  function initialise(json, reelSpinnerVisual) {
    reelSpinnerVisual.initialise(json);
  }

  function getRequiredFiles() {
    return [];
  }

  resourceManager.registerObjectType(
    'ReelSpinnerVisualNudge',
    create,
    initialise,
    getRequiredFiles
  );
})();
